/* eslint-disable react/sort-comp */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from 'react-places-autocomplete';
import { FormattedMessage } from 'react-intl';
import {} from 'mapbox-gl-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'leaflet.gridlayer.googlemutant';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import drawLocales from 'leaflet-draw-locales';
import { uniqueID } from '../../../utils/helpers';
import icon from '../../../icons/formMarker.png';
import styles from '../fields.module.scss';
import * as utils from '../../../utils/mapUtils';
import { CUSTOM_MAP, custom_map_max_zoom_level, get_custom_map_url } from '../../../constants/mapSettings';

const language = localStorage.getItem('lang') || 'en';
drawLocales(language !== 'az' ? language : 'en');

let locale = {};
if (language !== 'az') {
  locale = drawLocales(language);
  locale.draw.toolbar.buttons.polyline = 'click on this to draw polyline';
  locale.draw.toolbar.buttons.polygon = 'click on this to draw polygon';
  locale.draw.toolbar.buttons.marker = 'click on this to place an marker';
}
L.drawLocal = language === 'az' ? utils.azerbaijaniDrawLocale : locale;

class MapLocation extends Component {
  autoCompleteRef = React.createRef();

  constructor(props) {
    super(props);
    this.ID = uniqueID('map');
    const { isRequired, updateFieldErrors, answer } = this.props;
    if (isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    this.defaultConfig = {
      marker: false,
      circle: false,
      rectangle: false,
      polyline: false,
      circlemarker: false,
      polygon: false
    };
    this.slideStyles = {
      entered: { transform: 'translate3d(0px,0px)' }
    };
    this.state = {
      init: false,
      address: ''
    };
  }

  async componentDidMount() {
    const { airportInfo } = this.props;
    if (airportInfo && Object.keys(airportInfo).length > 0) {
      this.handleInitialMap();
    }
  }

  handleInitialMap = () => {
    this.setState({ init: true }, () => this.initializeMap());
  }

  componentWillUnmount() {
    if (this.map) this.map.remove();
  }

  handleAnswerChanged = (value, fieldId) => {
    const {
      handleValueChange,
      handleFieldErrorChanged,
      isRequired,
      updateFieldErrors
    } = this.props;

    handleValueChange(value, fieldId);
    let updatedErrors = [];
    if (value === '' || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  };

  initializeMap = () => {
    const {
      shape,
      fieldId,
      answer,
      disabled,
      addressEnabled,
      airportInfo,
      sms_form,
      enableDelete
    } = this.props;
    const { init } = this.state;
    const locationPoint = airportInfo.location;
    const curLocation = [locationPoint[1], locationPoint[0]];
    this.map = L.map(this.ID, {
      center: curLocation,
      zoom: 15,
      editable: true,
      attributionControl: false
    });
    if (airportInfo.map_style === 'map_box') {
      L.mapboxGL({
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
        style: airportInfo?.mapbox_style || sms_form?.mapbox_style || 'mapbox://styles/mapbox/satellite-v9'
      }).addTo(this.map);
      this.map._layersMaxZoom = 20;
    } else if (airportInfo?.map_style === CUSTOM_MAP) {
      L.tileLayer(get_custom_map_url(airportInfo?.custom_map_url), {
        maxZoom: custom_map_max_zoom_level
      }).addTo(this.map);
    } else {
      L.gridLayer
        .googleMutant({ type: 'satellite', maxZoom: 20 })
        .addTo(this.map);
    }
    const drawnItems = new L.FeatureGroup();

    this.map.addLayer(drawnItems);
    const CustomMarker = L.Icon.extend({
      options: {
        iconAnchor: [25, 35],
        iconUrl: icon
      }
    });
    const CreatedrawControl = new L.Control.Draw({
      edit: {
        featureGroup: drawnItems,
        remove: false,
        edit: false
      },
      draw: {
        ...this.defaultConfig,
        marker:
          shape === 'Point'
            ? {
                icon: new CustomMarker()
              }
            : false,
        polygon: shape === 'Polygon',
        polyline: shape === 'LineString'
      }
    });

    const EditdrawControl = new L.Control.Draw({
      edit: {
        featureGroup: drawnItems,
        remove: enableDelete,
        edit: true
      },
      draw: {
        ...this.defaultConfig
      }
    });
    if (answer && init) {
      if (shape === 'Point' && answer?.type === 'Point') {
        const marker = new L.Marker(answer.coordinates, {
          icon: new L.Icon({
            iconUrl: icon,
            iconAnchor: [25, 35]
          })
        });
        this.map.addLayer(marker);
        drawnItems.addLayer(marker);
        this.map.setView([...answer.coordinates], 18);
        if (!disabled) this.map.addControl(EditdrawControl);
      } else if (shape === 'Polygon' && answer?.type === 'Polygon') {
        const latlang = [];
        answer.coordinates[0].forEach((e) => {
          latlang.push([e[1], e[0]]);
        });
        const polygon = L.polygon(latlang).addTo(this.map);
        this.map.addLayer(polygon);
        drawnItems.addLayer(polygon);
        this.map.fitBounds(polygon.getBounds());
        if (!disabled) this.map.addControl(EditdrawControl);
      } else if (shape === 'LineString' && answer?.type === 'LineString') {
        const latlang = [];
        answer.coordinates.forEach((e) => {
          latlang.push([e[1], e[0]]);
        });
        const polyline = L.polyline(latlang).addTo(this.map);
        this.map.addLayer(polyline);
        drawnItems.addLayer(polyline);
        this.map.fitBounds(polyline.getBounds());
        if (!disabled) this.map.addControl(EditdrawControl);
      } else if (!disabled) this.map.addControl(CreatedrawControl);
    } else if (!disabled && !addressEnabled) {
      this.map.addControl(CreatedrawControl);
    }
    this.map.on(L.Draw.Event.CREATED, (e) => {
      const l = e.layer;
      this.map.addLayer(l);
      drawnItems.addLayer(l);
      this.map.addControl(EditdrawControl);
      this.map.removeControl(CreatedrawControl);
      let longlat = '';
      if (shape === 'Polygon') {
        const coordinates = l._latlngs[0].map(o => [o.lng, o.lat]);
        coordinates.push(coordinates[0]);
        longlat = { type: 'Polygon', coordinates: [coordinates] };
      }
      if (shape === 'LineString') {
        longlat = {
          type: 'LineString',
          coordinates: l._latlngs.map(o => [o.lng, o.lat])
        };
      }
      if (shape === 'Point') {
        longlat = {
          type: 'Point',
          coordinates: [l._latlng.lat, l._latlng.lng]
        };
      }
      this.handleAnswerChanged(longlat, fieldId);
    });
    this.map.on('draw:edited', (e) => {
      const layer = e.layers;
      layer.eachLayer((l) => {
        let longlat = '';
        if (shape === 'Polygon') {
          const coordinates = l._latlngs[0].map(o => [o.lng, o.lat]);
          coordinates.push(coordinates[0]);
          longlat = { type: 'Polygon', coordinates: [coordinates] };
        }
        if (shape === 'LineString') {
          longlat = {
            type: 'LineString',
            coordinates: l._latlngs.map(o => [o.lng, o.lat])
          };
        }
        if (shape === 'Point') {
          longlat = {
            type: 'Point',
            coordinates: [l._latlng.lat, l._latlng.lng]
          };
        }
        this.handleAnswerChanged(longlat, fieldId);
      });
    });
    if (enableDelete) {
      this.map.on('draw:deleted', (e) => {
        const layer = e.layers;
        layer.eachLayer((l) => {
          this.map.removeLayer(l);
          drawnItems.removeLayer(l);
          this.map.removeControl(EditdrawControl);
          this.handleAnswerChanged('', fieldId);
        });
        if (!disabled) {
          this.map.addControl(CreatedrawControl);
        }
      });
    }
  };

  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = (address) => {
    const { fieldId } = this.props;
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then((latLng) => {
        const geometry = latLng;
        const coordinates = [geometry.lat, geometry.lng];
        this.handleAnswerChanged(
          { type: 'Point', coordinates, address },
          fieldId
        );
        const marker = new L.Marker(coordinates, {
          icon: new L.Icon({
            iconUrl: icon,
            iconAnchor: [25, 35]
          })
        });
        this.map.addLayer(marker);
        this.map.setView([...coordinates], 18);
      })
      .catch(() => this.handleAnswerChanged(
        '',
        fieldId
      ));
    this.setState({ address });
  };

  render() {
    const {
      isRequired,
      locationId,
      locationTitle,
      addressEnabled
    } = this.props;
    return (
      <>
        {addressEnabled && (
          <>
            <PlacesAutocomplete
              value={this.state.address}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div>
                  <input
                    {...getInputProps({
                      placeholder: 'Search Places ...',
                      className: 'location-search-input'
                    })}
                  />
                  <div className="autocomplete-dropdown-container">
                    {loading && <div>Loading...</div>}
                    {suggestions.map((suggestion) => {
                      const className = suggestion.active
                        ? 'suggestion-item--active'
                        : 'suggestion-item';
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
            <div className={styles.margin} />
            <span className={styles.title}>
              {isRequired && <small style={{ color: 'red' }}> * </small>}
              <FormattedMessage
                id={locationId}
                defaultMessage={locationTitle}
              />
            </span>
          </>
        )}
        <div id={this.ID} className={styles.map} />
      </>
    );
  }
}

MapLocation.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  answer: PropTypes.arrayOf(PropTypes.number),
  defaultLocation: PropTypes.arrayOf(PropTypes.number)
};

MapLocation.defaultProps = {
  answer: undefined,
  defaultLocation: undefined
};

export default MapLocation;
